import { trimEnd } from 'lodash';

export const normalizePathname = (pathname: string): string => {
  const withoutTrailingSlashes = trimEnd(pathname, '/');
  return withoutTrailingSlashes === '' ? '/' : withoutTrailingSlashes;
};

export default normalizePathname;
